

import Layout from "../Layout";


import './Header.css'

function Header() {
    return (
       <header>
            <Layout />
       </header>
        
    );
}

export default Header;

